import React from 'react';
import { t } from '@lingui/core/macro';

import type { GalleryItem, PaginationConfig } from './ImageGallery.common';
import { GalleryViewMode } from './ImageGallery.common';
import ImageGrid from './ImageGrid';
import Lightbox from './Lightbox';
import Overlay from './Overlay';

type ImageGalleryProps = {
  images: GalleryItem[] | undefined;
  galleryViewMode: GalleryViewMode;
  lightboxIndex: number;
  setLightboxIndex: React.Dispatch<React.SetStateAction<number>>;
  onClose: () => void;
  onImageClick: (index: number) => void;
  onViewGallery?: () => void;
  pagination?: PaginationConfig;
  renderImageFooter?: (index: number) => React.ReactNode;
};

const ImageGallery = ({
  images,
  galleryViewMode,
  lightboxIndex,
  setLightboxIndex,
  onClose,
  onImageClick,
  onViewGallery,
  pagination,
  renderImageFooter,
}: ImageGalleryProps): JSX.Element => {
  if (galleryViewMode === GalleryViewMode.Grid) {
    return (
      <Overlay collapseMobilePx={false} onClose={onClose} ariaLabel={t`Image gallery`}>
        <ImageGrid
          images={images}
          onClose={onClose}
          onImageClick={onImageClick}
          pagination={pagination}
        />
      </Overlay>
    );
  }

  return (
    <Overlay collapseMobilePx onClose={onClose} ariaLabel={t`Image gallery`}>
      <Lightbox
        images={images}
        lightboxIndex={lightboxIndex}
        setLightboxIndex={setLightboxIndex}
        onClose={onClose}
        onViewGallery={onViewGallery}
        pagination={pagination}
        renderImageFooter={renderImageFooter}
      />
    </Overlay>
  );
};

export default ImageGallery;
